import { isDefined, isNotDefined } from '@sgme/fp';
import { Button, HStack } from '@sgme/ui';
import { type PropsWithChildren, useEffect, useState } from 'react';
import { FormattedMessage } from 'react-intl';

import type { IntlMessageId } from '@/types/intl.ts';

export type PanelProps = {
  labelId: IntlMessageId;
  isOpened?: boolean;
  onToggle?: (isOpened: boolean) => void;
  'data-e2e'?: string;
};

export const Panel = (props: PropsWithChildren<PanelProps>) => {
  const { labelId, isOpened, onToggle, ['data-e2e']: dataE2e } = props;

  const [isInternalOpened, setIsInternalOpened] = useState(isOpened);

  useEffect(() => {
    if (isDefined(isOpened)) {
      setIsInternalOpened(isOpened);
    }
  }, [isOpened]);

  const toggleIsOpened = () => {
    // if the value is not controlled, update it
    // else, call the onToggle function and wait to receive the updated value
    if (isNotDefined(isOpened)) {
      setIsInternalOpened(!isInternalOpened);
    }

    if (isDefined(onToggle)) {
      onToggle(!isInternalOpened);
    }
  };

  return (
    <div>
      <HStack verticalAlignment="center" fullWidth>
        <div className="flex-fill border-top" style={{ height: 1 }} />

        <Button size="sm" purpose="flat" onClick={toggleIsOpened} data-e2e={dataE2e}>
          <FormattedMessage id={labelId} />
          <i className="icon icon-sm">{isInternalOpened ? 'keyboard_arrow_up' : 'keyboard_arrow_down'}</i>
        </Button>

        <div className="flex-fill border-top" style={{ height: 1 }} />
      </HStack>

      {isInternalOpened && <div>{props.children}</div>}
    </div>
  );
};
